import {
    SET_SVC_REQUEST,
    SET_SVC_REQUEST_RAW
} from '../actions/actionTypes';

const initialState = {
    items: {
        summary:       '', 
        description:   '',
        priority:      null,
        issueTypes:    [],
        clientContact: '',
        client:        '',
        site:          '',
        target:        '',
        area:          [],
        areaId:        ''
    },
    raw: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SVC_REQUEST:
            return {
                ...state,
                raw: {
                    ...state.raw,
                    ...action.payload
                }
            };
        case SET_SVC_REQUEST_RAW:
            return {
                ...state,
                raw: action.payload
            };
        default:
            return state;
    }
};
